import Store from "../../../../Store/Store";

class PeriodContainer {
  public pickIdFromLabel(label) {
    const repeatPeriod = Store.getConfigurator().getState().globalTypes?.RepeatPeriod;
    for(const key in repeatPeriod) {
      if (repeatPeriod[key].label === label) {
        return repeatPeriod[key].id
      }
    }
  }

  public pickLabelFromId(id) {
    const repeatPeriod = Store.getConfigurator().getState().globalTypes?.RepeatPeriod;
    for(const key in repeatPeriod) {
      if (repeatPeriod[key].id === id) {
        return repeatPeriod[key].label
      }
    }
  }
}

export default new PeriodContainer();
